import * as React from "react";
import { observer } from "mobx-react";
import * as i from "../../../../contracts";
import { BaseDict } from "../../dict";
import * as RenderMethods from "./RenderMethods";

/* istanbul ignore next */
export type AggregateCardProps = {
    event: i.Event,
    sportId: string,
    handler: React.MouseEventHandler,
    dict: BaseDict
}

@observer
export class AggregateCard extends React.Component<AggregateCardProps, {}> {
    componentPrefix: string

    constructor(props) {
        super(props);
        this.componentPrefix = "aggregate-card";
    }

    renderEventsCount = RenderMethods.renderEventsCount;
    renderCardDetails = RenderMethods.renderCardDetails;
    renderArrow = RenderMethods.renderArrow;

    render () {
        return(
            <div className={`rj-ev-list__${this.componentPrefix}`} data-uat={`div-ev-list-${this.componentPrefix}`}>
                <a className={`rj-ev-list__${this.componentPrefix}__link`}
                    href={this.props.event.linkUrl}
                    onClick={this.props.handler}
                    key={`${this.componentPrefix}__link__${this.props.event.id}`}
                    data-uat={`a-ev-list-${this.componentPrefix}-link`}>
                    {this.renderEventsCount(this.props.event.aggregatedEventsCount, this.componentPrefix)}
                    {this.renderCardDetails(this.props, this.componentPrefix)}
                    {this.renderArrow(this.componentPrefix)}
                </a>
            </div>
        )
    }
}